import VStatus from '@voly/ui-components/src/v2/VStatus';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { EPriority } from 'src/app/project/modules/points/priorities';
import VText from '@voly/ui-components/src/v2/VText';
export type TPriorityOption = {
  value: EPriority;
  colorPalette: string;
  labelKey: string;
};

export const OPTION_BY_PRIORITY: Record<EPriority, TPriorityOption> = {
  [EPriority.LOW]: { value: EPriority.LOW, colorPalette: 'priorityLow', labelKey: 'low' },
  [EPriority.MEDIUM]: {
    value: EPriority.MEDIUM,
    colorPalette: 'priorityMedium',
    labelKey: 'medium',
  },
  [EPriority.HIGH]: { value: EPriority.HIGH, colorPalette: 'priorityHigh', labelKey: 'high' },
};

export const PRIORITY_OPTIONS = Object.values(OPTION_BY_PRIORITY);

export const findPriorityOption = (value: string): TPriorityOption | undefined =>
  PRIORITY_OPTIONS.find((option) => option.value === value);

const PriorityLabel = ({ option }: { option: TPriorityOption }): ReactElement => (
  <VStatus colorPalette={option.colorPalette} size="md">
    <VText>{translate(option.labelKey)}</VText>
  </VStatus>
);

export default PriorityLabel;
